import { Injectable } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { RideOpsUiService } from "source/app/configuration/services/rideops-ui.service";
import { ScannerComponent } from "./scanner.component";

@Injectable()
export class ScannerModalService {
	constructor(
		private modalController: ModalController,
		private rideOpsUi: RideOpsUiService,
	) {}

	create = () => {
		return this.modalController.create({
			id: ScannerComponent.modalId,
			cssClass: this.rideOpsUi.isV2Active() ? "scanner-modal scanner-modal-v2" : "scanner-modal",
			component: ScannerComponent,
		});
	};
}
